import React from 'react';
import styled from 'styled-components';

const DottedMatrixContainer = styled.div`
  position: absolute;
  right: ${(props) => (props.isLandscape ? '16px' : 'auto')};
  left: ${(props) => (props.isLandscape ? 'auto' : '16px')};
  bottom: 16px;
  width: 384px;
  height: 384px;
  z-index: -100;

  circle {
    fill: ${(props) => props.dotColor};
  }
`;

const DottedMatrix = (props) => {
  return (
    <DottedMatrixContainer
      isLandscape={props.isLandscape}
      dotColor={props.dotColor}
    >
      <svg
        width='384'
        height='384'
        viewBox='0 0 384 384'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <circle cx='2' cy='2' r='2' fill='#F7F8F9' />
        <circle cx='22' cy='2' r='2' fill='#F7F8F9' />
        <circle cx='42' cy='2' r='2' fill='#F7F8F9' />
        <circle cx='62' cy='2' r='2' fill='#F7F8F9' />
        <circle cx='82' cy='2' r='2' fill='#F7F8F9' />
        <circle cx='102' cy='2' r='2' fill='#F7F8F9' />
        <circle cx='122' cy='2' r='2' fill='#F7F8F9' />
        <circle cx='142' cy='2' r='2' fill='#F7F8F9' />
        <circle cx='162' cy='2' r='2' fill='#F7F8F9' />
        <circle cx='182' cy='2' r='2' fill='#F7F8F9' />
        <circle cx='202' cy='2' r='2' fill='#F7F8F9' />
        <circle cx='222' cy='2' r='2' fill='#F7F8F9' />
        <circle cx='242' cy='2' r='2' fill='#F7F8F9' />
        <circle cx='262' cy='2' r='2' fill='#F7F8F9' />
        <circle cx='282' cy='2' r='2' fill='#F7F8F9' />
        <circle cx='302' cy='2' r='2' fill='#F7F8F9' />
        <circle cx='322' cy='2' r='2' fill='#F7F8F9' />
        <circle cx='342' cy='2' r='2' fill='#F7F8F9' />
        <circle cx='362' cy='2' r='2' fill='#F7F8F9' />
        <circle cx='382' cy='2' r='2' fill='#F7F8F9' />
        <circle cx='2' cy='22' r='2' fill='#F7F8F9' />
        <circle cx='22' cy='22' r='2' fill='#F7F8F9' />
        <circle cx='42' cy='22' r='2' fill='#F7F8F9' />
        <circle cx='62' cy='22' r='2' fill='#F7F8F9' />
        <circle cx='82' cy='22' r='2' fill='#F7F8F9' />
        <circle cx='102' cy='22' r='2' fill='#F7F8F9' />
        <circle cx='122' cy='22' r='2' fill='#F7F8F9' />
        <circle cx='142' cy='22' r='2' fill='#F7F8F9' />
        <circle cx='162' cy='22' r='2' fill='#F7F8F9' />
        <circle cx='182' cy='22' r='2' fill='#F7F8F9' />
        <circle cx='202' cy='22' r='2' fill='#F7F8F9' />
        <circle cx='222' cy='22' r='2' fill='#F7F8F9' />
        <circle cx='242' cy='22' r='2' fill='#F7F8F9' />
        <circle cx='262' cy='22' r='2' fill='#F7F8F9' />
        <circle cx='282' cy='22' r='2' fill='#F7F8F9' />
        <circle cx='302' cy='22' r='2' fill='#F7F8F9' />
        <circle cx='322' cy='22' r='2' fill='#F7F8F9' />
        <circle cx='342' cy='22' r='2' fill='#F7F8F9' />
        <circle cx='362' cy='22' r='2' fill='#F7F8F9' />
        <circle cx='382' cy='22' r='2' fill='#F7F8F9' />
        <circle cx='2' cy='42' r='2' fill='#F7F8F9' />
        <circle cx='22' cy='42' r='2' fill='#F7F8F9' />
        <circle cx='42' cy='42' r='2' fill='#F7F8F9' />
        <circle cx='62' cy='42' r='2' fill='#F7F8F9' />
        <circle cx='82' cy='42' r='2' fill='#F7F8F9' />
        <circle cx='102' cy='42' r='2' fill='#F7F8F9' />
        <circle cx='122' cy='42' r='2' fill='#F7F8F9' />
        <circle cx='142' cy='42' r='2' fill='#F7F8F9' />
        <circle cx='162' cy='42' r='2' fill='#F7F8F9' />
        <circle cx='182' cy='42' r='2' fill='#F7F8F9' />
        <circle cx='202' cy='42' r='2' fill='#F7F8F9' />
        <circle cx='222' cy='42' r='2' fill='#F7F8F9' />
        <circle cx='242' cy='42' r='2' fill='#F7F8F9' />
        <circle cx='262' cy='42' r='2' fill='#F7F8F9' />
        <circle cx='282' cy='42' r='2' fill='#F7F8F9' />
        <circle cx='302' cy='42' r='2' fill='#F7F8F9' />
        <circle cx='322' cy='42' r='2' fill='#F7F8F9' />
        <circle cx='342' cy='42' r='2' fill='#F7F8F9' />
        <circle cx='362' cy='42' r='2' fill='#F7F8F9' />
        <circle cx='382' cy='42' r='2' fill='#F7F8F9' />
        <circle cx='2' cy='62' r='2' fill='#F7F8F9' />
        <circle cx='22' cy='62' r='2' fill='#F7F8F9' />
        <circle cx='42' cy='62' r='2' fill='#F7F8F9' />
        <circle cx='62' cy='62' r='2' fill='#F7F8F9' />
        <circle cx='82' cy='62' r='2' fill='#F7F8F9' />
        <circle cx='102' cy='62' r='2' fill='#F7F8F9' />
        <circle cx='122' cy='62' r='2' fill='#F7F8F9' />
        <circle cx='142' cy='62' r='2' fill='#F7F8F9' />
        <circle cx='162' cy='62' r='2' fill='#F7F8F9' />
        <circle cx='182' cy='62' r='2' fill='#F7F8F9' />
        <circle cx='202' cy='62' r='2' fill='#F7F8F9' />
        <circle cx='222' cy='62' r='2' fill='#F7F8F9' />
        <circle cx='242' cy='62' r='2' fill='#F7F8F9' />
        <circle cx='262' cy='62' r='2' fill='#F7F8F9' />
        <circle cx='282' cy='62' r='2' fill='#F7F8F9' />
        <circle cx='302' cy='62' r='2' fill='#F7F8F9' />
        <circle cx='322' cy='62' r='2' fill='#F7F8F9' />
        <circle cx='342' cy='62' r='2' fill='#F7F8F9' />
        <circle cx='362' cy='62' r='2' fill='#F7F8F9' />
        <circle cx='382' cy='62' r='2' fill='#F7F8F9' />
        <circle cx='2' cy='82' r='2' fill='#F7F8F9' />
        <circle cx='22' cy='82' r='2' fill='#F7F8F9' />
        <circle cx='42' cy='82' r='2' fill='#F7F8F9' />
        <circle cx='62' cy='82' r='2' fill='#F7F8F9' />
        <circle cx='82' cy='82' r='2' fill='#F7F8F9' />
        <circle cx='102' cy='82' r='2' fill='#F7F8F9' />
        <circle cx='122' cy='82' r='2' fill='#F7F8F9' />
        <circle cx='142' cy='82' r='2' fill='#F7F8F9' />
        <circle cx='162' cy='82' r='2' fill='#F7F8F9' />
        <circle cx='182' cy='82' r='2' fill='#F7F8F9' />
        <circle cx='202' cy='82' r='2' fill='#F7F8F9' />
        <circle cx='222' cy='82' r='2' fill='#F7F8F9' />
        <circle cx='242' cy='82' r='2' fill='#F7F8F9' />
        <circle cx='262' cy='82' r='2' fill='#F7F8F9' />
        <circle cx='282' cy='82' r='2' fill='#F7F8F9' />
        <circle cx='302' cy='82' r='2' fill='#F7F8F9' />
        <circle cx='322' cy='82' r='2' fill='#F7F8F9' />
        <circle cx='342' cy='82' r='2' fill='#F7F8F9' />
        <circle cx='362' cy='82' r='2' fill='#F7F8F9' />
        <circle cx='382' cy='82' r='2' fill='#F7F8F9' />
        <circle cx='2' cy='102' r='2' fill='#F7F8F9' />
        <circle cx='22' cy='102' r='2' fill='#F7F8F9' />
        <circle cx='42' cy='102' r='2' fill='#F7F8F9' />
        <circle cx='62' cy='102' r='2' fill='#F7F8F9' />
        <circle cx='82' cy='102' r='2' fill='#F7F8F9' />
        <circle cx='102' cy='102' r='2' fill='#F7F8F9' />
        <circle cx='122' cy='102' r='2' fill='#F7F8F9' />
        <circle cx='142' cy='102' r='2' fill='#F7F8F9' />
        <circle cx='162' cy='102' r='2' fill='#F7F8F9' />
        <circle cx='182' cy='102' r='2' fill='#F7F8F9' />
        <circle cx='202' cy='102' r='2' fill='#F7F8F9' />
        <circle cx='222' cy='102' r='2' fill='#F7F8F9' />
        <circle cx='242' cy='102' r='2' fill='#F7F8F9' />
        <circle cx='262' cy='102' r='2' fill='#F7F8F9' />
        <circle cx='282' cy='102' r='2' fill='#F7F8F9' />
        <circle cx='302' cy='102' r='2' fill='#F7F8F9' />
        <circle cx='322' cy='102' r='2' fill='#F7F8F9' />
        <circle cx='342' cy='102' r='2' fill='#F7F8F9' />
        <circle cx='362' cy='102' r='2' fill='#F7F8F9' />
        <circle cx='382' cy='102' r='2' fill='#F7F8F9' />
        <circle cx='2' cy='122' r='2' fill='#F7F8F9' />
        <circle cx='22' cy='122' r='2' fill='#F7F8F9' />
        <circle cx='42' cy='122' r='2' fill='#F7F8F9' />
        <circle cx='62' cy='122' r='2' fill='#F7F8F9' />
        <circle cx='82' cy='122' r='2' fill='#F7F8F9' />
        <circle cx='102' cy='122' r='2' fill='#F7F8F9' />
        <circle cx='122' cy='122' r='2' fill='#F7F8F9' />
        <circle cx='142' cy='122' r='2' fill='#F7F8F9' />
        <circle cx='162' cy='122' r='2' fill='#F7F8F9' />
        <circle cx='182' cy='122' r='2' fill='#F7F8F9' />
        <circle cx='202' cy='122' r='2' fill='#F7F8F9' />
        <circle cx='222' cy='122' r='2' fill='#F7F8F9' />
        <circle cx='242' cy='122' r='2' fill='#F7F8F9' />
        <circle cx='262' cy='122' r='2' fill='#F7F8F9' />
        <circle cx='282' cy='122' r='2' fill='#F7F8F9' />
        <circle cx='302' cy='122' r='2' fill='#F7F8F9' />
        <circle cx='322' cy='122' r='2' fill='#F7F8F9' />
        <circle cx='342' cy='122' r='2' fill='#F7F8F9' />
        <circle cx='362' cy='122' r='2' fill='#F7F8F9' />
        <circle cx='382' cy='122' r='2' fill='#F7F8F9' />
        <circle cx='2' cy='142' r='2' fill='#F7F8F9' />
        <circle cx='22' cy='142' r='2' fill='#F7F8F9' />
        <circle cx='42' cy='142' r='2' fill='#F7F8F9' />
        <circle cx='62' cy='142' r='2' fill='#F7F8F9' />
        <circle cx='82' cy='142' r='2' fill='#F7F8F9' />
        <circle cx='102' cy='142' r='2' fill='#F7F8F9' />
        <circle cx='122' cy='142' r='2' fill='#F7F8F9' />
        <circle cx='142' cy='142' r='2' fill='#F7F8F9' />
        <circle cx='162' cy='142' r='2' fill='#F7F8F9' />
        <circle cx='182' cy='142' r='2' fill='#F7F8F9' />
        <circle cx='202' cy='142' r='2' fill='#F7F8F9' />
        <circle cx='222' cy='142' r='2' fill='#F7F8F9' />
        <circle cx='242' cy='142' r='2' fill='#F7F8F9' />
        <circle cx='262' cy='142' r='2' fill='#F7F8F9' />
        <circle cx='282' cy='142' r='2' fill='#F7F8F9' />
        <circle cx='302' cy='142' r='2' fill='#F7F8F9' />
        <circle cx='322' cy='142' r='2' fill='#F7F8F9' />
        <circle cx='342' cy='142' r='2' fill='#F7F8F9' />
        <circle cx='362' cy='142' r='2' fill='#F7F8F9' />
        <circle cx='382' cy='142' r='2' fill='#F7F8F9' />
        <circle cx='2' cy='162' r='2' fill='#F7F8F9' />
        <circle cx='22' cy='162' r='2' fill='#F7F8F9' />
        <circle cx='42' cy='162' r='2' fill='#F7F8F9' />
        <circle cx='62' cy='162' r='2' fill='#F7F8F9' />
        <circle cx='82' cy='162' r='2' fill='#F7F8F9' />
        <circle cx='102' cy='162' r='2' fill='#F7F8F9' />
        <circle cx='122' cy='162' r='2' fill='#F7F8F9' />
        <circle cx='142' cy='162' r='2' fill='#F7F8F9' />
        <circle cx='162' cy='162' r='2' fill='#F7F8F9' />
        <circle cx='182' cy='162' r='2' fill='#F7F8F9' />
        <circle cx='202' cy='162' r='2' fill='#F7F8F9' />
        <circle cx='222' cy='162' r='2' fill='#F7F8F9' />
        <circle cx='242' cy='162' r='2' fill='#F7F8F9' />
        <circle cx='262' cy='162' r='2' fill='#F7F8F9' />
        <circle cx='282' cy='162' r='2' fill='#F7F8F9' />
        <circle cx='302' cy='162' r='2' fill='#F7F8F9' />
        <circle cx='322' cy='162' r='2' fill='#F7F8F9' />
        <circle cx='342' cy='162' r='2' fill='#F7F8F9' />
        <circle cx='362' cy='162' r='2' fill='#F7F8F9' />
        <circle cx='382' cy='162' r='2' fill='#F7F8F9' />
        <circle cx='2' cy='182' r='2' fill='#F7F8F9' />
        <circle cx='22' cy='182' r='2' fill='#F7F8F9' />
        <circle cx='42' cy='182' r='2' fill='#F7F8F9' />
        <circle cx='62' cy='182' r='2' fill='#F7F8F9' />
        <circle cx='82' cy='182' r='2' fill='#F7F8F9' />
        <circle cx='102' cy='182' r='2' fill='#F7F8F9' />
        <circle cx='122' cy='182' r='2' fill='#F7F8F9' />
        <circle cx='142' cy='182' r='2' fill='#F7F8F9' />
        <circle cx='162' cy='182' r='2' fill='#F7F8F9' />
        <circle cx='182' cy='182' r='2' fill='#F7F8F9' />
        <circle cx='202' cy='182' r='2' fill='#F7F8F9' />
        <circle cx='222' cy='182' r='2' fill='#F7F8F9' />
        <circle cx='242' cy='182' r='2' fill='#F7F8F9' />
        <circle cx='262' cy='182' r='2' fill='#F7F8F9' />
        <circle cx='282' cy='182' r='2' fill='#F7F8F9' />
        <circle cx='302' cy='182' r='2' fill='#F7F8F9' />
        <circle cx='322' cy='182' r='2' fill='#F7F8F9' />
        <circle cx='342' cy='182' r='2' fill='#F7F8F9' />
        <circle cx='362' cy='182' r='2' fill='#F7F8F9' />
        <circle cx='382' cy='182' r='2' fill='#F7F8F9' />
        <circle cx='2' cy='202' r='2' fill='#F7F8F9' />
        <circle cx='22' cy='202' r='2' fill='#F7F8F9' />
        <circle cx='42' cy='202' r='2' fill='#F7F8F9' />
        <circle cx='62' cy='202' r='2' fill='#F7F8F9' />
        <circle cx='82' cy='202' r='2' fill='#F7F8F9' />
        <circle cx='102' cy='202' r='2' fill='#F7F8F9' />
        <circle cx='122' cy='202' r='2' fill='#F7F8F9' />
        <circle cx='142' cy='202' r='2' fill='#F7F8F9' />
        <circle cx='162' cy='202' r='2' fill='#F7F8F9' />
        <circle cx='182' cy='202' r='2' fill='#F7F8F9' />
        <circle cx='202' cy='202' r='2' fill='#F7F8F9' />
        <circle cx='222' cy='202' r='2' fill='#F7F8F9' />
        <circle cx='242' cy='202' r='2' fill='#F7F8F9' />
        <circle cx='262' cy='202' r='2' fill='#F7F8F9' />
        <circle cx='282' cy='202' r='2' fill='#F7F8F9' />
        <circle cx='302' cy='202' r='2' fill='#F7F8F9' />
        <circle cx='322' cy='202' r='2' fill='#F7F8F9' />
        <circle cx='342' cy='202' r='2' fill='#F7F8F9' />
        <circle cx='362' cy='202' r='2' fill='#F7F8F9' />
        <circle cx='382' cy='202' r='2' fill='#F7F8F9' />
        <circle cx='2' cy='222' r='2' fill='#F7F8F9' />
        <circle cx='22' cy='222' r='2' fill='#F7F8F9' />
        <circle cx='42' cy='222' r='2' fill='#F7F8F9' />
        <circle cx='62' cy='222' r='2' fill='#F7F8F9' />
        <circle cx='82' cy='222' r='2' fill='#F7F8F9' />
        <circle cx='102' cy='222' r='2' fill='#F7F8F9' />
        <circle cx='122' cy='222' r='2' fill='#F7F8F9' />
        <circle cx='142' cy='222' r='2' fill='#F7F8F9' />
        <circle cx='162' cy='222' r='2' fill='#F7F8F9' />
        <circle cx='182' cy='222' r='2' fill='#F7F8F9' />
        <circle cx='202' cy='222' r='2' fill='#F7F8F9' />
        <circle cx='222' cy='222' r='2' fill='#F7F8F9' />
        <circle cx='242' cy='222' r='2' fill='#F7F8F9' />
        <circle cx='262' cy='222' r='2' fill='#F7F8F9' />
        <circle cx='282' cy='222' r='2' fill='#F7F8F9' />
        <circle cx='302' cy='222' r='2' fill='#F7F8F9' />
        <circle cx='322' cy='222' r='2' fill='#F7F8F9' />
        <circle cx='342' cy='222' r='2' fill='#F7F8F9' />
        <circle cx='362' cy='222' r='2' fill='#F7F8F9' />
        <circle cx='382' cy='222' r='2' fill='#F7F8F9' />
        <circle cx='2' cy='242' r='2' fill='#F7F8F9' />
        <circle cx='22' cy='242' r='2' fill='#F7F8F9' />
        <circle cx='42' cy='242' r='2' fill='#F7F8F9' />
        <circle cx='62' cy='242' r='2' fill='#F7F8F9' />
        <circle cx='82' cy='242' r='2' fill='#F7F8F9' />
        <circle cx='102' cy='242' r='2' fill='#F7F8F9' />
        <circle cx='122' cy='242' r='2' fill='#F7F8F9' />
        <circle cx='142' cy='242' r='2' fill='#F7F8F9' />
        <circle cx='162' cy='242' r='2' fill='#F7F8F9' />
        <circle cx='182' cy='242' r='2' fill='#F7F8F9' />
        <circle cx='202' cy='242' r='2' fill='#F7F8F9' />
        <circle cx='222' cy='242' r='2' fill='#F7F8F9' />
        <circle cx='242' cy='242' r='2' fill='#F7F8F9' />
        <circle cx='262' cy='242' r='2' fill='#F7F8F9' />
        <circle cx='282' cy='242' r='2' fill='#F7F8F9' />
        <circle cx='302' cy='242' r='2' fill='#F7F8F9' />
        <circle cx='322' cy='242' r='2' fill='#F7F8F9' />
        <circle cx='342' cy='242' r='2' fill='#F7F8F9' />
        <circle cx='362' cy='242' r='2' fill='#F7F8F9' />
        <circle cx='382' cy='242' r='2' fill='#F7F8F9' />
        <circle cx='2' cy='262' r='2' fill='#F7F8F9' />
        <circle cx='22' cy='262' r='2' fill='#F7F8F9' />
        <circle cx='42' cy='262' r='2' fill='#F7F8F9' />
        <circle cx='62' cy='262' r='2' fill='#F7F8F9' />
        <circle cx='82' cy='262' r='2' fill='#F7F8F9' />
        <circle cx='102' cy='262' r='2' fill='#F7F8F9' />
        <circle cx='122' cy='262' r='2' fill='#F7F8F9' />
        <circle cx='142' cy='262' r='2' fill='#F7F8F9' />
        <circle cx='162' cy='262' r='2' fill='#F7F8F9' />
        <circle cx='182' cy='262' r='2' fill='#F7F8F9' />
        <circle cx='202' cy='262' r='2' fill='#F7F8F9' />
        <circle cx='222' cy='262' r='2' fill='#F7F8F9' />
        <circle cx='242' cy='262' r='2' fill='#F7F8F9' />
        <circle cx='262' cy='262' r='2' fill='#F7F8F9' />
        <circle cx='282' cy='262' r='2' fill='#F7F8F9' />
        <circle cx='302' cy='262' r='2' fill='#F7F8F9' />
        <circle cx='322' cy='262' r='2' fill='#F7F8F9' />
        <circle cx='342' cy='262' r='2' fill='#F7F8F9' />
        <circle cx='362' cy='262' r='2' fill='#F7F8F9' />
        <circle cx='382' cy='262' r='2' fill='#F7F8F9' />
        <circle cx='2' cy='282' r='2' fill='#F7F8F9' />
        <circle cx='22' cy='282' r='2' fill='#F7F8F9' />
        <circle cx='42' cy='282' r='2' fill='#F7F8F9' />
        <circle cx='62' cy='282' r='2' fill='#F7F8F9' />
        <circle cx='82' cy='282' r='2' fill='#F7F8F9' />
        <circle cx='102' cy='282' r='2' fill='#F7F8F9' />
        <circle cx='122' cy='282' r='2' fill='#F7F8F9' />
        <circle cx='142' cy='282' r='2' fill='#F7F8F9' />
        <circle cx='162' cy='282' r='2' fill='#F7F8F9' />
        <circle cx='182' cy='282' r='2' fill='#F7F8F9' />
        <circle cx='202' cy='282' r='2' fill='#F7F8F9' />
        <circle cx='222' cy='282' r='2' fill='#F7F8F9' />
        <circle cx='242' cy='282' r='2' fill='#F7F8F9' />
        <circle cx='262' cy='282' r='2' fill='#F7F8F9' />
        <circle cx='282' cy='282' r='2' fill='#F7F8F9' />
        <circle cx='302' cy='282' r='2' fill='#F7F8F9' />
        <circle cx='322' cy='282' r='2' fill='#F7F8F9' />
        <circle cx='342' cy='282' r='2' fill='#F7F8F9' />
        <circle cx='362' cy='282' r='2' fill='#F7F8F9' />
        <circle cx='382' cy='282' r='2' fill='#F7F8F9' />
        <circle cx='2' cy='302' r='2' fill='#F7F8F9' />
        <circle cx='22' cy='302' r='2' fill='#F7F8F9' />
        <circle cx='42' cy='302' r='2' fill='#F7F8F9' />
        <circle cx='62' cy='302' r='2' fill='#F7F8F9' />
        <circle cx='82' cy='302' r='2' fill='#F7F8F9' />
        <circle cx='102' cy='302' r='2' fill='#F7F8F9' />
        <circle cx='122' cy='302' r='2' fill='#F7F8F9' />
        <circle cx='142' cy='302' r='2' fill='#F7F8F9' />
        <circle cx='162' cy='302' r='2' fill='#F7F8F9' />
        <circle cx='182' cy='302' r='2' fill='#F7F8F9' />
        <circle cx='202' cy='302' r='2' fill='#F7F8F9' />
        <circle cx='222' cy='302' r='2' fill='#F7F8F9' />
        <circle cx='242' cy='302' r='2' fill='#F7F8F9' />
        <circle cx='262' cy='302' r='2' fill='#F7F8F9' />
        <circle cx='282' cy='302' r='2' fill='#F7F8F9' />
        <circle cx='302' cy='302' r='2' fill='#F7F8F9' />
        <circle cx='322' cy='302' r='2' fill='#F7F8F9' />
        <circle cx='342' cy='302' r='2' fill='#F7F8F9' />
        <circle cx='362' cy='302' r='2' fill='#F7F8F9' />
        <circle cx='382' cy='302' r='2' fill='#F7F8F9' />
        <circle cx='2' cy='322' r='2' fill='#F7F8F9' />
        <circle cx='22' cy='322' r='2' fill='#F7F8F9' />
        <circle cx='42' cy='322' r='2' fill='#F7F8F9' />
        <circle cx='62' cy='322' r='2' fill='#F7F8F9' />
        <circle cx='82' cy='322' r='2' fill='#F7F8F9' />
        <circle cx='102' cy='322' r='2' fill='#F7F8F9' />
        <circle cx='122' cy='322' r='2' fill='#F7F8F9' />
        <circle cx='142' cy='322' r='2' fill='#F7F8F9' />
        <circle cx='162' cy='322' r='2' fill='#F7F8F9' />
        <circle cx='182' cy='322' r='2' fill='#F7F8F9' />
        <circle cx='202' cy='322' r='2' fill='#F7F8F9' />
        <circle cx='222' cy='322' r='2' fill='#F7F8F9' />
        <circle cx='242' cy='322' r='2' fill='#F7F8F9' />
        <circle cx='262' cy='322' r='2' fill='#F7F8F9' />
        <circle cx='282' cy='322' r='2' fill='#F7F8F9' />
        <circle cx='302' cy='322' r='2' fill='#F7F8F9' />
        <circle cx='322' cy='322' r='2' fill='#F7F8F9' />
        <circle cx='342' cy='322' r='2' fill='#F7F8F9' />
        <circle cx='362' cy='322' r='2' fill='#F7F8F9' />
        <circle cx='382' cy='322' r='2' fill='#F7F8F9' />
        <circle cx='2' cy='342' r='2' fill='#F7F8F9' />
        <circle cx='22' cy='342' r='2' fill='#F7F8F9' />
        <circle cx='42' cy='342' r='2' fill='#F7F8F9' />
        <circle cx='62' cy='342' r='2' fill='#F7F8F9' />
        <circle cx='82' cy='342' r='2' fill='#F7F8F9' />
        <circle cx='102' cy='342' r='2' fill='#F7F8F9' />
        <circle cx='122' cy='342' r='2' fill='#F7F8F9' />
        <circle cx='142' cy='342' r='2' fill='#F7F8F9' />
        <circle cx='162' cy='342' r='2' fill='#F7F8F9' />
        <circle cx='182' cy='342' r='2' fill='#F7F8F9' />
        <circle cx='202' cy='342' r='2' fill='#F7F8F9' />
        <circle cx='222' cy='342' r='2' fill='#F7F8F9' />
        <circle cx='242' cy='342' r='2' fill='#F7F8F9' />
        <circle cx='262' cy='342' r='2' fill='#F7F8F9' />
        <circle cx='282' cy='342' r='2' fill='#F7F8F9' />
        <circle cx='302' cy='342' r='2' fill='#F7F8F9' />
        <circle cx='322' cy='342' r='2' fill='#F7F8F9' />
        <circle cx='342' cy='342' r='2' fill='#F7F8F9' />
        <circle cx='362' cy='342' r='2' fill='#F7F8F9' />
        <circle cx='382' cy='342' r='2' fill='#F7F8F9' />
        <circle cx='2' cy='362' r='2' fill='#F7F8F9' />
        <circle cx='22' cy='362' r='2' fill='#F7F8F9' />
        <circle cx='42' cy='362' r='2' fill='#F7F8F9' />
        <circle cx='62' cy='362' r='2' fill='#F7F8F9' />
        <circle cx='82' cy='362' r='2' fill='#F7F8F9' />
        <circle cx='102' cy='362' r='2' fill='#F7F8F9' />
        <circle cx='122' cy='362' r='2' fill='#F7F8F9' />
        <circle cx='142' cy='362' r='2' fill='#F7F8F9' />
        <circle cx='162' cy='362' r='2' fill='#F7F8F9' />
        <circle cx='182' cy='362' r='2' fill='#F7F8F9' />
        <circle cx='202' cy='362' r='2' fill='#F7F8F9' />
        <circle cx='222' cy='362' r='2' fill='#F7F8F9' />
        <circle cx='242' cy='362' r='2' fill='#F7F8F9' />
        <circle cx='262' cy='362' r='2' fill='#F7F8F9' />
        <circle cx='282' cy='362' r='2' fill='#F7F8F9' />
        <circle cx='302' cy='362' r='2' fill='#F7F8F9' />
        <circle cx='322' cy='362' r='2' fill='#F7F8F9' />
        <circle cx='342' cy='362' r='2' fill='#F7F8F9' />
        <circle cx='362' cy='362' r='2' fill='#F7F8F9' />
        <circle cx='382' cy='362' r='2' fill='#F7F8F9' />
        <circle cx='2' cy='382' r='2' fill='#F7F8F9' />
        <circle cx='22' cy='382' r='2' fill='#F7F8F9' />
        <circle cx='42' cy='382' r='2' fill='#F7F8F9' />
        <circle cx='62' cy='382' r='2' fill='#F7F8F9' />
        <circle cx='82' cy='382' r='2' fill='#F7F8F9' />
        <circle cx='102' cy='382' r='2' fill='#F7F8F9' />
        <circle cx='122' cy='382' r='2' fill='#F7F8F9' />
        <circle cx='142' cy='382' r='2' fill='#F7F8F9' />
        <circle cx='162' cy='382' r='2' fill='#F7F8F9' />
        <circle cx='182' cy='382' r='2' fill='#F7F8F9' />
        <circle cx='202' cy='382' r='2' fill='#F7F8F9' />
        <circle cx='222' cy='382' r='2' fill='#F7F8F9' />
        <circle cx='242' cy='382' r='2' fill='#F7F8F9' />
        <circle cx='262' cy='382' r='2' fill='#F7F8F9' />
        <circle cx='282' cy='382' r='2' fill='#F7F8F9' />
        <circle cx='302' cy='382' r='2' fill='#F7F8F9' />
        <circle cx='322' cy='382' r='2' fill='#F7F8F9' />
        <circle cx='342' cy='382' r='2' fill='#F7F8F9' />
        <circle cx='362' cy='382' r='2' fill='#F7F8F9' />
        <circle cx='382' cy='382' r='2' fill='#F7F8F9' />
      </svg>
    </DottedMatrixContainer>
  );
};

export default DottedMatrix;
